import { deviceDetect, mobileModel, mobileVendor, isMobile } from 'react-device-detect';
import { getCke } from '../helper/cookieHelper';

export async function reportErrorViaWebhook(errorMessage, apiUrl) {
  const url = 'https://hooks.slack.com/services/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';
  const displayObj = {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `*Api URL/path:*\n${apiUrl}`
        }
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `*Called From:*\n${window.location.href}`
        }
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `*Error Message:*\n${errorMessage}`
        }
      },
      {
        type: 'section',
        fields: [
          {
            type: 'mrkdwn',
            text: `*Logged-in User:*\n${getCke('userId')}`
          },
          {
            type: 'mrkdwn',
            text: `*User Agent:*\n${deviceDetect().userAgent}`
          },
          {
            type: 'mrkdwn',
            text: `*OS Name:*\n${deviceDetect().osName}`
          },
          {
            type: 'mrkdwn',
            text: `*OS Version:*\n${deviceDetect().osVersion}`
          },
          {
            type: 'mrkdwn',
            text: `*Browser Name:*\n${deviceDetect().browserName}`
          }
        ]
      }
    ]
  };
  if (isMobile) {
    displayObj.blocks[2].fields.push(
      {
        type: 'mrkdwn',
        text: `*Mobile Modal:*\n${mobileModel}`
      },
      {
        type: 'mrkdwn',
        text: `*Mobile Vendor:*\n${mobileVendor}`
      }
    );
  }
  fetch(url, {
    body: JSON.stringify(displayObj),
    method: 'post'
  });
  // return axios({
  //   method: 'POST',
  //   url,
  //   data: displayObj
  //   // headers: {
  //   //   'Content-type': 'application/x-www-form-urlencoded'
  //   // }
  // });
}
